import { createContext } from "react"

type TranslationsContextType = {
  t: (key: string, options?: Record<string, string>) => string
  onLanguageChange: (lang: string) => void
  currentLanguage: string
}

export const TranslationsContext = createContext<TranslationsContextType>({
  t: () => "",
  onLanguageChange: (_lang: string) => undefined,
  currentLanguage: "en",
})
type Props = {
  children: React.ReactNode
  t: (key: string, options?: Record<string, string>) => string
  onLanguageChange: (lang: string) => void
  currentLanguage: string
}
export const TranslationsProvider = ({
  children,
  t,
  onLanguageChange,
  currentLanguage,
}: Props) => {
  return (
    <TranslationsContext.Provider
      value={{ t, onLanguageChange, currentLanguage }}
    >
      {children}
    </TranslationsContext.Provider>
  )
}
